import { useState } from "react";
import EyeLocked from "../assets/icons/eye-locked";
import EyeUnlocked from "../assets/icons/eye-unlocked";

export default function PasswordField({
  name,
  required,
  onChange = () => {},
  check_format = true,
}) {
  const [field_type, setFieldType] = useState("password");
  return (
    <div className="d-flex align-items-center position-relative">
      <input
        name={name}
        onChange={(e) => onChange(e)}
        type={field_type}
        pattern={
          check_format ? "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$" : null
        }
        className="w-100"
        required={required}
      />
      {field_type === "password" ? (
        <div
          style={{ right: 15, marginTop: 5 }}
          className="position-absolute d-flex align-items-center"
          onClick={() => setFieldType("text")}
        >
          <EyeUnlocked
            size={24}
            color="#000000"
            onClick={() => setFieldType("text")}
          />
        </div>
      ) : (
        <div
          style={{ right: 15, marginTop: 5 }}
          className="position-absolute d-flex align-items-center"
        >
          <EyeLocked
            size={24}
            color="#000000"
            onClick={() => setFieldType("password")}
          />
        </div>
      )}
    </div>
  );
}
